// src/components/Features.js
import React from "react";
import { MapPin, Search, Download } from 'lucide-react';

const Features = () => {
  const features = [
    {
      title: "Nationwide Data",
      icon: <MapPin className="w-12 h-12 text-blue-600 mx-auto mb-4" />,
      shortText: "Access property data from all U.S. states and regions.",
      longText: "Explore an extensive database covering every U.S. state and region, providing comprehensive property details such as ownership records, historical sales, and geographic information to support your real estate decisions.",
    },
    {
      title: "Detailed Insights",
      icon: <Search className="w-12 h-12 text-blue-600 mx-auto mb-4" />,
      shortText: "Get in-depth analytics on sales and market trends.",
      longText: "Leverage advanced analytics to uncover sales patterns, market trends, and predictive insights, helping you make informed decisions with detailed reports on pricing, demand, and regional performance.",
    },
    {
      title: "Downloadable Files",
      icon: <Download className="w-12 h-12 text-blue-600 mx-auto mb-4" />,
      shortText: "Purchase and download tailored datasets instantly.",
      longText: "Download custom datasets tailored to your needs, available instantly after purchase, including raw data, summaries, and visualizations for in-depth analysis and integration into your workflows.",
    },
  ];

  return (
    <>
      <style>
        {`
          .flip-card {
            perspective: 1000px;
          }

          .flip-card-inner {
            position: relative;
            width: 100%;
            height: 100%;
            transition: transform 0.6s;
            transform-style: preserve-3d;
          }

          .flip-card-front, .flip-card-back {
            position: absolute;
            width: 100%;
            height: 100%;
            backface-visibility: hidden;
          }

          .flip-card-back {
            transform: rotateY(180deg);
          }

          .backface-hidden {
            backface-visibility: hidden;
          }

          .hover\\:rotate-y-180:hover {
            transform: rotateY(180deg);
          }

          .animate-slideUp {
            animation: slideUp 0.5s ease-out forwards;
          }

          @keyframes slideUp {
            from {
              opacity: 0;
              transform: translateY(20px);
            }
            to {
              opacity: 1;
              transform: translateY(0);
            }
          }

          .animate-fadeInUp {
            animation: fadeInUp 0.5s ease-out forwards;
          }

          @keyframes fadeInUp {
            from {
              opacity: 0;
              transform: translateY(20px);
            }
            to {
              opacity: 1;
              transform: translateY(0);
            }
          }
        `}
      </style>
      <section id="features" className="py-12 bg-transparent">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16 animate-fadeInUp">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">Key Features :</h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Discover the tools to access and utilize U.S. real estate data effectively.
            </p>
          </div>

          <div className="grid lg:grid-cols-3 gap-12">
            {features.map((feature, index) => (
              <div
                key={index}
                className="flip-card w-full h-72"
              >
                <div className="flip-card-inner relative w-full h-full transition-transform duration-500 transform-style-3d hover:rotate-y-180">
                  {/* Front Side */}
                  <div className="flip-card-front absolute w-full h-full bg-white p-6 rounded-xl shadow-md text-center flex flex-col items-center justify-center animate-slideUp"
                    style={{ animationDelay: `${index * 100}ms` }}
                  >
                    {feature.icon}
                    <h3 className="text-xl font-semibold text-gray-900 mb-2">{feature.title}</h3>
                    <p className="text-gray-600">{feature.shortText}</p>
                  </div>
                  {/* Back Side */}
                  <div className="flip-card-back absolute w-full h-full bg-blue-50 p-6 rounded-xl shadow-md flex items-center justify-center text-center text-gray-700 rotate-y-180 backface-hidden">
                    <p className="text-sm">{feature.longText}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default Features;